import moment from "moment";
import React, { useCallback } from "react";
import { useMembers } from "../../../../context/members/MembersProvider";
import { useToast } from "../../../../context/toast";
import { useWorkspaces } from "../../../../context/workspaces";
import { PlanType } from "../../../../utils/types";

interface Props {}

const DangerZonePage: React.FC<Props> = () => {
  const { setModalWarningConfig } = useToast();
  const { deleteWorkspace, currentWorkspace } = useWorkspaces();
  const { isCurrentUserAdmin } = useMembers();

  const handleDeleteWorkspace = useCallback(() => {
    let message =
      "Once you delete this workspace, there is no going back. All data will be lost for everyone that currently has access to this workspace. Please be certain.";

    const hableToDelete =
      currentWorkspace?.active_plan.type === PlanType.community;

    if (!hableToDelete) {
      message = `Please, downgrade to community plan before deleting this workspace`;
    }

    if (currentWorkspace?.downgrade) {
      message = `Please, await downgrade to community plan before deleting this workspace, you still have ${moment(
        currentWorkspace.downgrade.date
      ).fromNow()}`;
    }

    setModalWarningConfig({
      title: "Delete workspace confirmation",
      message,
      confirmButtonText: hableToDelete ? "Delete workspace" : "OK",
      open: true,
      resolve: async () => {
        if (!hableToDelete) return;

        await deleteWorkspace();
      }
    });
  }, [
    currentWorkspace?.active_plan.type,
    currentWorkspace?.downgrade,
    deleteWorkspace,
    setModalWarningConfig
  ]);

  return (
    <div className="flex flex-col w-full">
      <div className="mb-6">
        <h1 className="text-lg leading-6 font-medium text-gray-900 dark:text-white">
          Danger zone
        </h1>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-300">
          This section contains irreversible actions. Be careful!
        </p>
      </div>

      {!isCurrentUserAdmin ? (
        <span className="text-sm">
          Your permissions do not allow access to the danger zone for this
          workspace.
        </span>
      ) : (
        <div className="flex flex-col sm:flex-row">
          <div className="flex-1 flex flex-col">
            <div className="text-sm font-medium mb-1 text-gray-900 dark:text-white">
              Delete this workspace
            </div>
            <div className="text-sm text-gray-500 dark:text-gray-200">
              Once you delete a workspace, there is no going back. Please be
              certain.
            </div>
          </div>
          <div className="flex items-center mt-4 sm:mt-0">
            <button
              type="button"
              className="bg-red-600 hover:bg-red-700 flex items-center justify-center rounded-md border border-transparent shadow-sm px-2.5 py-1.5 text-sm font-medium text-white focus:outline-none hover:opacity-75 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={() => handleDeleteWorkspace()}
            >
              Delete workspace
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DangerZonePage;
